import React, { useEffect, useState } from 'react';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';
import { getTranslationKey } from '../../modules/utils';
import styled from 'styled-components';
import { ShopTaxSetupForm } from './ShopTaxSetupForm';
import { useSelector } from 'react-redux';
import { getRequiredTaxSaved, getUser } from '../../modules/selectors';

const Description = styled.p``;

export const ShopTaxModal = () => {
  const { taxSettings, registrationProcess } = useSelector(getUser);
  const taxIsSaved = useSelector(getRequiredTaxSaved);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const billingAddressFailed = localStorage.getItem('taxModalBillingAddressFailed') === 'true';
    const hasPreviouslySetUpTax = registrationProcess?.setTaxDetails === true;

    if (hasPreviouslySetUpTax && (billingAddressFailed || !taxSettings.isConfirmed)) {
      setIsOpen(true);
    }
  }, [taxSettings]); // eslint-disable-line
  useEffect(() => {
    if (taxIsSaved) {
      localStorage.removeItem('taxModalBillingAddressFailed');
      setIsOpen(false);
    }
  }, [taxIsSaved]); // eslint-disable-line

  return (
    <Modal isOpen={isOpen} wrapClassName="modal-dark" size="default" centered>
      <ModalHeader>{getTranslationKey('shop.taxConfig.shopModalTitle')}</ModalHeader>
      <ModalBody>
        <Description className="text-muted">
          {getTranslationKey('shop.taxConfig.shopModalText')}
        </Description>
        <ShopTaxSetupForm isTaxModal />
      </ModalBody>
    </Modal>
  );
};
